/**
 * Turkish — the second surface language.
 *
 * **PM review needed.** Everything here except the strings lifted verbatim from the design
 * boards was written by the build agent, which the prompt permits for shell chrome only.
 * Marked strings came from `docs/design/studio/studio-shell-option-d.html`'s TR frame and
 * are the design's own wording.
 *
 * Turkish runs longer than English, so the shell is laid out for the longer of the two;
 * the diacritics to watch are ç ğ ı ö ş ü.
 */

import type { Catalog } from './en.js';

export const tr: Catalog = {
  'app.skipToMain': 'İçeriğe geç',
  'app.opening': 'Stüdyo açılıyor…',
  'app.mainLabel': 'Stüdyo yüzeyi',
  'narrow.title': 'Stüdyo daha geniş bir ekran istiyor',
  'narrow.body':
    'Burası bir atölye, bir akış değil — çizim var, sürükleme var ve bir bakışta görmen gereken bir ızgara var. Tablette ya da bilgisayarda açılır. Oradan geldiğinde her şey bıraktığın yerde olacak.',

  'nav.sections': 'Stüdyo bölümleri', // ← design board
  'nav.library': 'Kitaplık', // ← design board
  'nav.stories': 'Hikâyeler', // ← design board
  'nav.browse': 'Keşfet', // ← design board

  'cluster.making': '{count} yapılıyor', // ← design board
  'cluster.makingNothing': 'Şu an bir şey yapılmıyor',
  'cluster.generations': 'Üretimler', // ← design board
  'cluster.generationsUnset': 'henüz ayarlanmadı', // ← design board
  'cluster.generationsUsed': '{cap} üretimden {used}',

  'rail.label': 'Bağlam rayı', // ← design board
  'rail.shelfTitle': 'Kitaplığın', // ← design board
  'rail.search': 'Kitaplığında ara', // ← design board
  'rail.searchPlaceholder': 'Ara', // ← design board
  'rail.siblingsTitle': 'Bunun yanında',
  'rail.back': 'kitaplığına dön',
  'rail.stateTitle': 'Yapılanlar',
  'rail.stateNeedsYou': 'Seni bekleyenler',
  'rail.stateNothing': 'Şu an yapılan bir şey yok.',
  'rail.sourceTitle': 'Kitaplığından al',
  'rail.empty': 'Burada henüz bir şey yok.',

  'kind.characters': 'Karakterler', // ← design board
  'kind.settings': 'Mekânlar', // ← design board
  'kind.props': 'Eşyalar', // ← design board
  'kind.beats': 'Anlar', // ← design board

  'floor.label': 'Seni bekleyenler',
  'floor.nothing': 'Seni bekleyen bir şey yok',
  'floor.needsOkOne': '1 tanesi onayını bekliyor',
  'floor.needsOkMany': '{count} tanesi onayını bekliyor', // ← design board
  'floor.review': 'incele', // ← design board

  'account.label': 'Hesap · {name}', // ← design board
  'account.menu': 'Hesap',
  'account.signedInAs': '{email} olarak girdin',
  'account.signOut': 'Çıkış yap',
  'account.language': 'Dil',
  'account.languageEn': 'English',
  'account.languageTr': 'Türkçe',
  'account.theme': 'Görünüm',
  'account.themeSystem': 'Sistem',
  'account.themeLight': 'Gündüz',
  'account.themeDark': 'Gece',
  'account.methods': 'Giriş yolu: {methods}',
  'account.methodLink': 'e-posta bağlantısı',
  'account.methodPassword': 'şifre',
  'account.methodGoogle': 'Google',
  'account.methodEmail': 'e-posta',
  'account.verifyNote': 'E-postanı doğrula — sana bir bağlantı gönderdik.',
  'account.verifyConsequence':
    'Doğrulayana kadar, bu adresle Google ile giriş yapmak şifreni değiştirir.', // ← board
  'account.verifyResend': 'Tekrar gönder',
  'account.verifyDismiss': 'Şimdi değil',
  'account.verifySent': 'Doğrulama e-postası gönderildi.',
  'account.changePassword': 'Şifreyi değiştir',
  'account.setPassword': 'Bir şifre belirle',

  'signin.title': 'Hoş geldin',
  'signin.lead':
    'E-postanı yaz, sonra nasıl gireceğini seç: sana göndereceğimiz bir bağlantı, bir şifre ya da Google hesabın.',
  'signin.email': 'E-posta',
  'signin.emailPlaceholder': 'sen@ornek.com',
  'signin.send': 'Bana bağlantı gönder',
  'signin.sending': 'Gönderiliyor…',
  'signin.usePassword': 'Şifre kullan',
  'signin.password': 'Şifre',
  'signin.passwordRequired': 'Şifren lazım.',
  'signin.passwordTooShort': 'En az 8 karakter.',
  'signin.signIn': 'Giriş yap',
  'signin.create': 'Hesap oluştur',
  'signin.forgot': 'Unuttun mu?',
  'signin.working': 'Bir saniye…',
  'signin.or': 'ya da',
  'signin.google': 'Google ile devam et',
  'signin.sentTitle': 'E-postana bak',
  'signin.sentBody': '{email} adresine bir giriş bağlantısı gönderdik. Bu cihazda aç.',
  'signin.sentAgain': 'Başka bir e-posta kullan',
  'signin.resetTitle': 'E-postana bak',
  'signin.resetBody':
    '{email} adresine bir şifre sıfırlama bağlantısı gönderdik. O adrese ait bir hesap yoksa bir şey gelmeyecek.',
  'signin.back': 'Geri',
  'signin.finishing': 'Giriş yapılıyor…',
  'signin.confirmEmailTitle': 'Bir şey daha',
  'signin.confirmEmailBody':
    'Bağlantıyı başka bir cihazda ya da tarayıcıda açtın. Bağlantıyı istediğin e-postayı yaz.',
  'signin.confirmEmailAction': 'Girişi tamamla',
  'signin.offerPassword': 'Onun yerine şifreni kullan.',
  'signin.offerLink': 'Onun yerine bana bağlantı gönder.',
  'signin.emailRequired': 'Bir e-posta adresi lazım.',
  'signin.failed': 'Bu işe yaramadı. Tekrar dene.',
  'signin.emulator': 'Yerel sürüm — bağlantı {url} adresindeki Auth emülatöründe.',

  'signin.errBadCredentials':
    'Bu e-posta ile şifre eşleşmiyor — ya da henüz bir hesap yok. Tekrar dene, şifreni sıfırla ya da bir hesap oluştur.',
  'signin.errEmailInUse':
    'Bu e-posta için zaten bir hesap var. Şifresiyle gir ya da şifreyi sıfırla.',
  'signin.errWeakPassword': 'Daha uzun bir şifre lazım — en az 8 karakter.',
  'signin.errTooMany': 'Çok fazla deneme oldu. Biraz bekle, sonra tekrar dene.',
  'signin.errNetwork': 'Giriş servisine ulaşamadık. Bağlantını kontrol edip tekrar dene.',
  'signin.errInvalidEmail': 'Bu bir e-posta adresine benzemiyor.',
  'signin.errPopup': 'Google penceresi kapandı ya da engellendi. Tekrar dene.',
  'signin.errMethodOff': 'Bu giriş yolu açık değil. Başka birini dene.',
  'signin.errRecentLogin': 'Önce yeniden giriş yap, sonra bir daha dene.',
  'signin.errAccountExistsLink': 'Bu adres zaten e-posta bağlantısıyla giriyor.',
  'signin.errAccountExistsPassword': 'Bu adres zaten şifreyle giriyor.',

  'password.changeTitle': 'Şifreni değiştir',
  'password.setTitle': 'Bir şifre belirle',
  'password.setBody':
    'Zaten girdiğin yolun yanına bir şifre. Bağlantın ve Google hesabın çalışmaya devam eder.',
  'password.current': 'Mevcut şifre',
  'password.next': 'Yeni şifre',
  'password.nextHelp': 'En az 8 karakter.',
  'password.required': 'Mevcut şifren lazım.',
  'password.confirm': 'Kaydet',
  'password.cancel': 'Vazgeç',
  'password.working': 'Kaydediliyor…',
  'password.changed': 'Şifre değiştirildi.',
  'password.set': 'Şifre belirlendi.',
  'password.errCurrent': 'Bu mevcut şifren değil.',
  'password.errRecentLogin':
    'Firebase bunun için yeni bir giriş istiyor. Çıkış yap, yeni bir bağlantıyla gir ve tekrar dene.',

  'status.none': 'Henüz referans yok', // ← board
  'status.making': 'Yapılıyor', // ← board
  'status.needsOk': 'Onayını bekliyor', // ← board
  'status.ready': 'Hazır', // ← board
  'status.readyLocked': 'Hazır · Kilitli', // ← board
  'status.error': 'Geri gelmedi', // ← board
  'status.nothingMadeYet': 'Henüz çizilmedi', // ← board
  'status.noImage': 'görsel yok', // ← board
  'status.modelSheetMin': 'model sayfası · ~1 dk', // ← board

  'kind.character': 'Karakter', // ← board
  'kind.setting': 'Mekân', // ← board
  'kind.prop': 'Eşya', // ← board
  'kind.beat': 'An', // ← board
  'kind.characterArchived': 'Karakter · arşivde', // ← board
  'kind.settingArchived': 'Mekân · arşivde',
  'kind.propArchived': 'Eşya · arşivde', // ← board
  'kind.beatArchived': 'An · arşivde',

  'library.pieces': '{count} parça',
  'library.piecesArchived': '{count} parça · {archived} arşivde', // ← board
  'library.nothingHereYet': 'henüz burada bir şey yok', // ← board
  'library.adopt': 'Keşfet’ten uyarla', // ← board
  'library.newCharacter': 'Yeni karakter', // ← board
  'library.newSetting': 'Yeni mekân',
  'library.newProp': 'Yeni eşya',
  'library.newBeat': 'Yeni an', // ← board
  'library.actions': '{name} — işlemler', // ← board
  'library.editCharacter': 'Karakteri düzenle',
  'library.editSetting': 'Mekânı düzenle',
  'library.editProp': 'Eşyayı düzenle',
  'library.editBeat': 'Anı düzenle',
  'library.archive': 'Arşivle', // ← board
  'library.make': 'Yap', // ← board
  'library.tryAgain': 'Tekrar dene', // ← board
  'library.archived': 'Arşivdekiler', // ← board
  'library.archiveSection': 'Arşiv', // ← board
  'library.archivedNote':
    'Arşivdekiler raftan kalkar ama silinmez. Onları kullanan hikâyeler eskisi gibi çalışmaya devam eder. Kalıcı olarak yalnızca hiçbir şeyin kullanmadığı bir parça silinebilir.', // ← board
  'library.archivedMeta': '{count} parça · hikâyelerde çalışmaya devam ediyor', // ← board
  'library.restore': 'Geri getir', // ← board
  'library.delete': 'Kalıcı sil', // ← board
  'library.usedByStories': '{count} hikâyede kullanılıyor', // ← board
  'library.usedByOneStory': '1 hikâyede kullanılıyor',
  'library.stillInStories': 'Hâlâ {count} hikâyede geçiyor ve orada çalışmaya devam ediyor.', // ← board
  'library.nothingUses': 'Hiçbir hikâyede kullanılmıyor. İstersen kalıcı olarak silebilirsin.', // ← board
  'library.noMatches': 'eşleşen yok',
  'library.noMatchesBody': 'Yazdığınla eşleşen bir şey yok. Daha kısa bir kelime dene.',
  'library.checking': 'bakılıyor…',

  'empty.characters.title': 'Henüz karakter yok.',
  'empty.characters.body':
    'Karakter, hikâyenin anlattığı kişidir — çocuğun, tilkisi, komşunun köpeği. Kim olduğunu yazarsın; sonra her sahnede aynı görünür.',
  'empty.settings.title': 'Henüz mekân yok.',
  'empty.settings.body':
    'Mekân, içinde kimse olmayan bir yerdir — herkesin üzerine yerleştiği temiz bir fon. Ay ışığındaki bahçe, gece limanı.',
  'empty.props.title': 'Henüz eşya yok.',
  'empty.props.body':
    'Eşya, bir karakterin taşıdığı ya da sahnenin ihtiyaç duyduğu şeydir — bir fener, bir düdük, bir çiçek.',
  'empty.beats.title': 'Henüz bir an yok.', // ← board
  'empty.beats.body':
    'Anlar, birden fazla karakterin aynı karede buluştuğu küçük sahnelerdir — “Atlas tilkiye bir çiçek uzatır” gibi. Bir hikâye istediğinde yaparsın.', // ← board
  'empty.adopt': 'ya da Keşfet’ten uyarla', // ← board

  'new.character': 'Yeni bir karakter',
  'new.setting': 'Yeni bir mekân',
  'new.prop': 'Yeni bir eşya',
  'new.beat': 'Yeni bir an',
  'new.body': 'Önce bir ad ver. Kim olduğunu yazmayı ve çizdirmeyi sonra yaparsın.',
  'new.bodyThing': 'Önce bir ad ver. Ne olduğunu yazmayı ve çizdirmeyi sonra yaparsın.',
  'new.name': 'Ad',
  'new.namePlaceholder': 'Sable',
  'new.create': 'Oluştur',
  'new.nameRequired': 'Bir ad lazım.',

  'cost.oneGeneration': '1 üretim',
  'ledger.monthSpent': 'Bu ayın resimleri bu kadar. {date} tarihinde yeniden başlar.',
  'spend.notNow': 'Vazgeç', // ← board
  'spend.oneGeneration': '{gen} harcar · yaklaşık bir dakika', // ← board
  'make.title': 'Bunu şimdi yapalım mı?', // ← board
  'make.body':
    'Bir model sayfası çizeceğiz — birkaç poz ve ifade, tek bir görselde. Geldiğinde onu görüp onaylayacaksın; onaylanmadan başka hiçbir şey üretilmez.', // ← board
  'make.bodyPlain': 'Yazdıklarından bir kez çizeriz. Sen görmeden hiçbir şey kilitlenmez.',
  'make.confirm': 'Yap', // ← board
  'make.thisCosts': 'Bu {gen} harcar · yaklaşık bir dakika', // ← board

  'delete.title': 'Kalıcı olarak silinsin mi?', // ← board
  'delete.body':
    'Bu, {name} parçasını ve onun için üretilmiş her görseli kalıcı olarak siler. Geri alınamaz. Hiçbir hikâye onu kullanmadığı için silinebiliyor.', // ← board
  'delete.bodyDrawings':
    'Bu, {name} karakterini ve çizimlerini kalıcı olarak siler. Geri alınamaz. Hiçbir hikâye onu kullanmadığı için silinebiliyor.',
  'delete.keep': 'Vazgeç', // ← board
  'delete.confirm': 'Kalıcı olarak sil', // ← board
  'delete.refusedTitle': 'Hâlâ kullanılıyor',
  'delete.refusedBody':
    'Bir şey onu kullandığı sürece {name} silinemez. Arşivde kalır ve onu kullanan her şey çalışmaya devam eder.',
  'delete.usedByStory': '“{title}” hikâyesi',
  'delete.usedByRender': 'yaptığın bir çıktı',
  'delete.usedByGlobal': 'ortak raf',
  'delete.close': 'Kapat', // ← board

  'toast.undo': 'Geri al',
  'toast.archivedUsed': 'Arşivlendi. Hâlâ {count} hikâyede ve orada çalışmaya devam ediyor.', // ← board
  'toast.archivedFree': '{name} arşivlendi. İstediğin an geri getirebilirsin.', // ← board
  'toast.restored': '{name} rafına geri döndü.',
  'toast.optionRemoved': '“{option}” seçeneği kaldırıldı. Yapılmış varyantları duruyor.', // ← board
  'toast.deleted': '{name} kalıcı olarak silindi.',

  'beat.cast': 'Kimler var',
  'beat.castNone': 'henüz kimse',
  'beat.castCount': '{count} karakter',
  'beat.castHint':
    'Bir an, tam olarak bu karakterler için çizilir. Kimlerin olduğunu değiştirmek onu başka bir an yapar, o yüzden sürümü artar.',
  'beat.castNoCharacters': 'Önce bir karakter yap — an, onların arasında geçen bir şey.',

  'piece.kickerVersion': '{kind} · s{version}',
  'piece.kickerLocked': '{kind} · s{version} · kilitli', // ← board
  'piece.variantsMadeOpen': '{made} varyant yapıldı · {open} açık', // ← board
  'piece.identity': 'Kimlik', // ← board
  'piece.identityLocked': 'kilitli · s{version}', // ← board
  'piece.identityLead':
    'Onu o yapan şey: birkaç satır ve, istersen, bir çizim. İkisi de burada düzenlenir.', // ← board
  'piece.identityLeadThing':
    'Onu o yapan şey: birkaç satır ve, istersen, bir çizim. İkisi de burada düzenlenir.',
  'piece.identityEmpty':
    'Henüz bir şey yazılmadı. Çizim, kim olduğuna dair birkaç satırdan çıkıyor.',
  'piece.identityHint':
    'Bunu değiştirirsen sürümü artar ve onunla yeniden tanışırsın — kilit bir kapı değil, bir seçim.', // ← board
  'piece.identityHintThing': 'Bunu değiştirirsen sürümü artar ve yeniden çizilir.',
  'piece.identityEdit': 'Kimliği düzenle', // ← board
  'piece.identityEditNote': 'notlar ve çizim birlikte · bir kayıt, bir sürüm', // ← board
  'piece.identityConsequence':
    'Bu satırlar ve bu çizim {name} karakterini {name} yapan şey. Kaydedersen sürümü s{next} olur ve onunla yeniden tanışırsın; şimdiye kadar yapılan resimler s{version} olarak kalır.', // ← board
  'piece.identityConsequenceFirst':
    'Bu satırlar ve bu çizim {name} karakterini {name} yapan şey. Kaydedersen sürümü s{next} olur.',
  'piece.identityConsequenceThing':
    'Bu satırlar ve bu çizim {name} parçasının ne olduğu. Kaydedersen sürümü s{next} olur; şimdiye kadar yapılan resimler s{version} olarak kalır.',
  'piece.identityConsequenceThingFirst':
    'Bu satırlar ve bu çizim {name} parçasının ne olduğu. Kaydedersen sürümü s{next} olur.',
  'piece.identityQuestion': 'Kim o?', // ← board
  'piece.identityQuestionThing': 'Bu ne?',
  'piece.identityNotesHelp':
    'Onu o yapan ve hiç değişmeyen şeyler. Pozlar ve ifadeler buraya değil, eksenlere ait.', // ← board
  'piece.identityNotesHelpThing':
    'Onun ne olduğu ve hiç değişmeyen şeyler. Değişme yolları buraya değil, eksenlere ait.',
  'piece.identityCost': 'Kaydetmek ücretsiz · yeniden çizmek {gen} harcar', // ← board
  'piece.identitySave': 'Kaydet ve yeniden tanış', // ← board
  'piece.identitySaveThing': 'Kaydet',
  'piece.save': 'Kaydet', // ← board
  'piece.cancel': 'Vazgeç', // ← board
  'piece.colourAnchor': 'Kaymaması gereken renkler',
  'piece.colourAnchorHelp': 'Siyah şapka siyah kalmalı. Önemli renkleri yaz.',

  'piece.drawing': 'Örnek alınacak bir çizim',
  'piece.drawingChoose': 'Üzerinden çalışılacak bir çizim seç',
  'piece.drawingAdd': 'Çizim ekle',
  'piece.drawingYours': 'Senin çizimin', // ← board
  'piece.drawingLabel': 'Çizim', // ← board
  'piece.drawingOptional': 'isteğe bağlı', // ← board
  'piece.drawingNone': 'Çizim yok',
  'piece.drawingNeverPhoto': 'bir çizim — asla fotoğraf', // ← board
  'piece.drawingReplaceShort': 'Değiştir', // ← board
  'piece.drawingRemoveShort': 'kaldır', // ← board
  'piece.drawingPrivate': 'Yalnızca sana ait. Kitaplığından çıkmaz.',
  'piece.drawingWrongType': 'PNG, JPEG ya da WebP olmalı.',
  'piece.drawingTooLarge': 'Bu dosya 10 MB’tan büyük. Daha küçüğü lazım.',
  'piece.drawingFailed': 'Yüklenemedi. Tekrar dener misin?',

  'piece.baseReference': 'Temel referans',
  'piece.baseReferenceCrop': 'Temel referans · kanonik kırpım', // ← board
  'piece.modelSheet': 'Model sayfası', // ← board
  'piece.modelSheetSplit': 'Model sayfası · {count} poz ayrıldı', // ← board
  'piece.sheetSource': 'kaynak', // ← board
  'piece.sheetNote':
    'Bu sayfa, ona karar verdiğin an. Pozları başlangıç varyantlarına ayrıldı; geri kalanı istediğinde yapılır.', // ← board
  'piece.noReferenceYet': 'Henüz çizilmedi',
  'piece.generate': 'Onu çiz',
  'piece.generateThing': 'Onu çiz',
  'piece.remake': 'Yeniden yap', // ← board
  'piece.meetThem': '{name} ile tanış',
  'piece.backdropNote': 'Karaktersiz, temiz bir fon. Herkes bunun üzerine yerleşir.', // ← board
  'piece.drawingBeforeGenerate':
    'Önce kim olduğuna dair bir satır yaz — çizim kelimelerden çıkıyor.',

  'axes.title': 'Varyant eksenleri', // ← board
  'axes.options': '{count} seçenek', // ← board
  'axes.addOption': 'seçenek ekle', // ← board
  'axes.addAxis': 'yeni bir değişkenlik ekle',
  'axes.removeOption': '{axis} seçeneği {option} kaldır', // ← board
  'axes.removeAxis': '{axis} eksenini kaldır',
  'axes.newOption': 'Yeni {axis} seçeneği', // ← board
  'axes.axisActions': '{axis} — işlemler',
  'axes.renameAxis': '{axis} eksenini yeniden adlandır',
  'axes.renameOption': '{axis} seçeneği {option} yeniden adlandır',
  'axes.newAxis': 'Ne değişiyor? (poz, mevsim, durum…)',
  'axes.hint':
    'Eksenleri değiştirmek referansı bozmaz — sürüm yalnızca kimliği izler. Kaldırdığın bir seçeneğin yapılmış varyantları kitaplıkta kalır.', // ← board
  'axes.bound': 'En fazla 4 değişkenlik, her birinde 8 seçenek.',
  'axes.tooBig':
    'Bu kadar seçenek, Stüdyonun tutacağından fazla varyant tarif eder. En fazla 4 değişkenlik, her birinde 8 seçenek.',
  'axes.none':
    'Henüz bir değişkenlik yok. Bir tane ekle, aşağıdaki tablo neler yapabileceğinle dolsun.',

  'matrix.title': 'Varyantlar', // ← board
  'matrix.label': '{name} varyantları — {columns} × {rows}', // ← board
  'matrix.labelOne': '{name} varyantları — {columns}',
  'matrix.hint':
    'Bu tablonun çoğu bilerek boş. Bir hücre eksik değil — henüz istemediğin bir şey. Dokunduğunda yapılır.', // ← board
  'matrix.cost': 'Bir varyant yapmak {gen} harcar. Çoğu varyant hiç yapılmaz, tasarım da bu.', // ← board
  'matrix.blocked': 'Referansın doğru olduğunu söyleyene kadar başka hiçbir şey yapılmaz.',
  'matrix.tapToMake': 'dokun, yapılsın', // ← board
  'matrix.making': 'Yapılıyor', // ← board
  'matrix.didntComeBack': 'geri gelmedi', // ← board
  'matrix.tryAgain': 'tekrar dene', // ← board
  'matrix.fromSheet': 'sayfadan',
  'matrix.cellOpen': '{name}, {point} — bunu yap',
  'matrix.cellFilled': '{name}, {point} — aç',
  'matrix.cellMaking': '{name}, {point} — yapılıyor',
  'matrix.cellError': '{name}, {point} — geri gelmedi, tekrar dene',
  'matrix.cellBlocked': '{name}, {point} — referansı onaylamanı bekliyor',
  'matrix.thirdAxis': '{axis}: {option}', // ← board
  'matrix.makeTitle': 'Bu varyantı yapalım mı?', // ← board
  'matrix.makeBody': '{name}, {point} — kanonik kırpımından, olduğu gibi.', // ← board
  'matrix.makeConfirm': 'Yap', // ← board
  'matrix.remakeTitle': 'Bunu yeniden yapalım mı?', // ← board
  'matrix.remakeBody':
    'Şu anki görsel değişir. Beğenmezsen tekrar yapabilirsin, ama her seferinde bir üretim harcanır.', // ← board
  'matrix.remakeKeep': 'Vazgeç', // ← board
  'matrix.remakeConfirm': 'Yeniden yap', // ← board
  'matrix.remakeCost': 'Yeniden yapmak {gen} harcar', // ← board
  'matrix.viewerVariant': 'varyant · s{version}’den', // ← board
  'matrix.close': 'Kapat', // ← board

  'piece.remakeRefTitle': '{name} yeniden mi çizilsin?', // ← board
  'piece.remakeRefBody':
    'Yeni bir model sayfası çizilir ve onunla yeniden tanışırsın. Yapılmış varyantları kitaplıkta kalır; yeni sayfayı onaylarsan bundan sonrakiler ona göre yapılır.', // ← board
  'piece.remakeRefConfirm': 'Yeniden çiz', // ← board

  'meet.kicker': 'Karakterinle tanış', // ← board
  'meet.pageTitle': '{name} ile tanış',
  'meet.question': 'İşte {name} — tanıdın değil mi?', // ← board
  'meet.drawnFrom':
    'Notlarından çizildi: {notes} Doğruysa kilitlenir — her sahnede, her hikâyede, her biçimde bu {name} görünür.', // ← board
  'meet.drawnFromPlain':
    'Yazdıklarından çizildi. Doğruysa kilitlenir — her sahnede, her hikâyede, her biçimde bu {name} görünür.',
  'meet.takeYourTime': 'Acele etme. Bunu onaylayana kadar başka hiçbir şey üretilmez.', // ← board
  'meet.yes': 'Evet — bu o', // ← board
  'meet.remake': 'Yeniden çiz', // ← board
  'meet.remakeCost': 'Yeniden çizmek {gen} harcar', // ← board
  'meet.sheetPoses': '{count} poz', // ← board
  'meet.lockedKicker': 'Tanıştınız', // ← board
  'meet.lockedTitle': '{name} artık kilitli.', // ← board
  'meet.lockedSaying':
    'Sayfasındaki pozlar başlangıç varyantlarına ayrıldı. Bundan sonra ne yaparsan yap, aynı {name} olacak.', // ← board
  'meet.seeVariants': 'Varyantlarına git', // ← board
  'meet.backToLibrary': 'Kitaplığına dön', // ← board
  'meet.lockedNote':
    'Kimlik notlarını değiştirirsen sürümü artar ve bu an yeniden açılır. Kilit bir kapı değil — fikrini değiştirebilirsin.', // ← board
  'meet.lockedToast': '{name} kilitlendi. Başlangıç varyantları sayfasından ayrılıyor.', // ← board
  'meet.splitting': 'Sayfa başlangıç varyantlarına ayrılıyor…',
  'meet.remakeRecommendedTitle': 'Bu sayfa biraz sorunlu çıktı',
  'meet.remakeRecommendedBody':
    '{expected} pozdan yalnızca {usable} tanesi temiz çıktı — {reason} Yeniden çizmek genelde düzeltir; yine de beğendiysen bunu onaylayabilirsin.',
  'meet.remakeDialogTitle': '{name} yeniden mi çizilsin?', // ← board
  'meet.remakeDialogBody':
    'Yeni bir model sayfası çizeriz ve onu yeniden görürsün. Notlarını değiştirmek istersen önce onu yapmak daha iyi olur — çizim notlardan çıkıyor.', // ← board
  'meet.staleTitle': '{name} bu çizimden sonra değişti',
  'meet.staleBody':
    'Kim olduğunu değiştirdin, yani bu sayfa eski hâlinin. Yeniden çiz ve yenisiyle tanış — yapılmış hiçbir şey kaybolmaz.',
  'meet.staleAction': 'Yeniden çiz',
  'meet.nothingToMeet': 'Henüz tanışılacak bir şey yok',
  'meet.nothingToMeetBody': 'Önce {name} çizilsin; bu sayfada o mu değil mi ona karar verirsin.',
  'meet.notACharacter': 'Böyle bir an yalnızca karakterlerde olur.',

  'stories.title': 'Hikâyelerin', // ← board
  'stories.count': '{count} hikâye', // ← board
  'stories.countOne': '1 hikâye',
  'stories.new': 'Yeni hikâye', // ← board
  'stories.bring': 'Bir hikâye getir', // ← board
  'stories.inProgress': 'Üzerinde çalıştıkların', // ← board
  'stories.made': 'Yapılanlar', // ← board
  'stories.outputs': '{count} çıktı', // ← board
  'stories.kindDraft': 'Hikâye · taslak', // ← board
  'stories.kindMade': 'Hikâye · yapıldı',
  'stories.kindMadeAs': 'Hikâye · yapıldı · {format}',
  'stories.kindArchived': 'Hikâye · arşivde',
  'stories.noScenes': 'Henüz sahne yok', // ← board
  'stories.madeOf': '{scenes} sahne · {cast}',
  'stories.madeOfOne': '1 sahne · {cast}',
  'stories.madeOfNoCast': '{scenes} sahne',
  'stories.nothingComposed': 'Adı kondu, henüz hiçbir şey kurulmadı — hazır olduğunda başlarsın.', // ← board
  'stories.statusNothing': 'Henüz kurulmadı', // ← board
  'stories.statusComposing': 'Sahneler çözülüyor', // ← board
  'stories.statusReady': 'Yapılmaya hazır', // ← board
  'stories.continue': 'devam et', // ← board
  'stories.composeFirst': 'ilk sahneyi kur', // ← board
  'stories.makeIt': 'yap', // ← board
  'stories.railNothing': 'Şu an yapılan bir şey yok.',
  'stories.railScenes': '{total} sahneden {done}’ü', // ← board pattern
  'stories.meet': 'tanış', // ← board
  'stories.noLibraryHere':
    'Kitaplığındaki parçalar burada görünmez. Burası yalnızca yapılmakta olan ve seni bekleyen şeyler için — kitaplık kendi sekmesinde duruyor.', // ← board
  'stories.emptyTitle': 'Henüz hikâye yok.',
  'stories.emptyBody':
    'Hikâye, elindeki parçalardan kurulmuş birkaç sahnedir. Önce bir ad ver — kurmak ücretsiz, yalnızca resimler harcar.',
  'stories.newTitle': 'Yeni bir hikâye',
  'stories.newBody': 'Bir başlık ver. İstediğin zaman değiştirebilirsin.',
  'stories.newName': 'Başlık',
  'stories.newPlaceholder': 'Gece limanı',
  'stories.archived': 'Arşivdeki hikâyeler',
  'stories.archivedNote':
    'Arşivlenen bir hikâye listeden kalkar ama silinmez — ondan yapılmış her şey çalışmaya devam eder. Kalıcı olarak yalnızca hiçbir çıktısı olmayan bir hikâye silinebilir.',
  'stories.deleteBody':
    'Bu, {name} hikâyesini ve onun için kurulmuş her şeyi kalıcı olarak siler. Geri alınamaz. Ondan bir şey yapılmadığı için silinebiliyor.',

  'compose.stage': 'Resim, çizileceği hâliyle',
  'compose.stageEmpty': 'Bir mekân seç, sonra kimin olduğunu.', // ← board
  'compose.itemLabel': '{name} — {state}. Oklarla taşı, shift+oklarla boyutlandır.',
  'compose.itemSelected': 'seçili', // ← board
  'compose.itemUnselected': 'seçmek için dokun', // ← board
  'compose.placedByRole': 'rolüne göre yerleşti — istersen elle ayarla', // ← board
  'compose.roleBackdrop': 'fon · arkada', // ← board
  'compose.roleCharacter': 'karakter · ortada', // ← board
  'compose.roleProp': 'eşya · önde', // ← board
  'compose.source': 'Kitaplığından al', // ← board
  'toast.region': 'Mesajlar',
  'compose.sources': 'Yerleştirebileceğin parçalar',
  'compose.pickAdd': 'ekle', // ← board
  'compose.pickPlaced': 'yerleşti', // ← board
  'compose.pickBlockedCharacter': 'önce {name} ile tanış',
  'compose.pickBlockedPiece': 'önce {name} çizilsin',
  'compose.pickMaking': 'çiziliyor',
  'compose.variantDraw': 'çiz', // ← board
  'compose.variantCost': 'yapılmış olan ücretsiz · yenisi {gen}', // ← board
  'compose.variantDone': 'Tamam', // ← board
  'compose.layerOrder':
    'fon arkada · karakterler ortada · eşyalar önde — rolüne göre yerleşti, istersen elle ayarla', // ← board
  'compose.selectedLabel': 'seçili', // ← board
  'compose.placementNth': '{n} yerleşim', // ← board
  'compose.placementBack': 'arkada', // ← board
  'compose.placementFront': 'önde', // ← board
  'compose.placedTwice': '×{n} · sahnede seç', // ← board
  'compose.inThisPicture': 'bu resimde', // ← board
  'compose.inThisPlacement': 'bu yerleşimde · {n}/{of}', // ← board
  'compose.removePiece': '{name} bu resimden çıkarılsın',
  'compose.adjustPieces': 'parçaları ayarla',
  'compose.showPicture': 'resmi göster',
  'compose.layersOf': '{count} katman · hepsi zaten kitaplığında', // ← board
  'compose.layersNothingNew':
    'Buradaki her katman zaten kitaplığında — bu resim yeni bir şey üretmedi.', // ← board
  'compose.layerBackdrop': 'arkada', // ← board
  'compose.layerCharacter': 'ortada', // ← board
  'compose.layerProp': 'önde', // ← board
  'compose.layerForeground': 'önde',
  'compose.flatComposite': 'birleşik',
  'compose.flatRelit': 'yeniden ışıklandırıldı',
  'compose.pictureCost': 'Bu resim {gen} harcar', // ← board
  'compose.pictureCostMany': 'Bu resim {count} üretim harcar',
  'compose.pictureCostNone': 'Bu resmin kullandığı her şey zaten yapıldı',

  'story.kicker': 'Bir hikâye · {count} an', // ← board
  'story.kickerOne': 'Bir hikâye · 1 an',
  // Turkish does not inflect a noun after a numeral — *1 resim* and *3 resim* alike — so all
  // three twins repeat their other form. That is the language, not an oversight.
  'story.meta': '{ready} resim hazır · {making} yapılıyor',
  'story.metaOne': '{ready} resim hazır · {making} yapılıyor',
  'story.metaNoneMaking': '{ready} resim hazır',
  'story.metaNoneMakingOne': '{ready} resim hazır',
  'story.metaFailed': '{failed} geri gelmedi', // ← board
  'story.metaFailedOne': '{failed} geri gelmedi', // ← board
  'story.metaNothingYet': 'henüz resim çizilmedi',
  'story.backToStories': 'hikâyelere dön', // ← board
  'story.statusNotDrawn': 'Bu resim henüz çizilmedi', // ← board
  'story.statusMaking': 'Yapılıyor', // ← board
  'story.statusReady': 'Hazır', // ← board
  'story.statusFailed': 'Geri gelmedi', // ← board
  'story.formats': 'Biçimler', // ← board
  'story.draw': 'Bu resmi çiz', // ← board
  'story.drawAgain': 'Yeniden çiz', // ← board
  'story.lineLabel': '{index}. anın satırı', // ← board
  'story.lineHelp': 'yüksek sesle okuyacağın satır', // ← board
  'story.viewLabel': 'Bu resmi nasıl görelim', // ← board
  'story.viewPicture': 'Resim', // ← board
  'story.viewLayers': 'Katmanlar', // ← board
  'story.book': 'Kitap', // ← board
  'story.bookMeta': 'kapak · {count} an · son', // ← board
  'story.bookLabel': 'Kitap, sayfa sayfa', // ← board
  'story.cover': 'kapak', // ← board
  'story.coverLabel': 'Kapak — {title}', // ← board
  'story.leafLabel': '{index}. an — {line}', // ← board
  'story.leafLabelOpen': '{index}. an — {line}, şu an açık', // ← board
  'story.leafMaking': 'yapılıyor', // ← board
  'story.leafFailed': 'geri gelmedi', // ← board
  'story.theEnd': 'Son.', // ← board
  'story.theEndCap': 'son', // ← board
  'story.theEndLabel': 'Son sayfa — Son', // ← board
  'story.beats': 'Anlar', // ← board
  'story.beatsInOrder': '{count} · sırayla', // ← board
  'story.beatsLabel': 'Anlar, okuma sırasıyla', // ← board
  'story.reorder': 'Sırala — {index}. an. Yukarı ve aşağı oklarını kullan.',
  'story.moved': 'An {total} içinde {index}. sıraya taşındı.',
  'story.beatActions': '{index}. an işlemleri',
  'story.duplicate': 'Anı çoğalt', // ← board
  'story.duplicated': '{index}. an çoğaltıldı. Kopya aynı resim ve hiçbir şey harcamaz.',
  'story.sameAs': '{index}. anla aynı resim — bir şeyi kaydır ya da varyantı değiştir',
  'story.useOnCover': 'Kapağa bu resmi koy', // ← board
  'story.onCover': 'kapakta',
  'story.remove': 'Hikâyeden çıkar', // ← board
  'story.removeTitle': 'Bu an çıkarılsın mı?',
  'story.removeBody':
    'Çizdiği resim kitaplığında kalır ve geri getirmek hiçbir şey harcamaz — yalnızca anın hikâyedeki yeri gider.',
  'story.removeConfirm': 'Çıkar',
  'story.rowReady': 'Hazır', // ← board
  'story.rowPlaced': 'Kuruldu, çizilmedi', // ← board
  'story.rowEmpty': 'Henüz bir şey konmadı', // ← board
  'story.rowMaking': 'Yapılıyor', // ← board
  'story.rowFailed': 'Geri gelmedi', // ← board
  'story.retry': 'tekrar dene', // ← board
  'story.thumbOpen': 'açık', // ← board
  'story.thumbEmpty': 'boş', // ← board
  'story.addBeat': 'An ekle', // ← board
  'story.addBeatFree': 'an eklemek ücretsiz', // ← board
  'story.note':
    'Bu sayfa hikâyenin kendisi: her anın bir satırı ve bir resmi var. Biçime dair hiçbir şey burada yaşamaz — akordeon, kartlar, tünel kitap kendi tuvallerinde.', // ← board
  'story.drawTitle': 'Bu resmi çizelim mi?', // ← board
  'story.drawBodyFree':
    '{pieces} tek bir resme dönüşür. Kullandığı her parça zaten hazır, yani kimsenin yeni bir hâli çizilmeyecek.', // ← board
  'story.drawBodyCost':
    '{pieces} tek bir resme dönüşür. Bunlardan {count} tanesi henüz çizilmedi, önce onlar yapılır.',
  'story.drawGo': 'Çiz', // ← board
  'story.drawNotYet': 'Vazgeç', // ← board
  'story.pieces': 'Parçalar',
  'story.and': 've',
  'story.openBeat': 'aç', // ← board
  'story.beatReady': 'hazır', // ← board
  'story.beatMaking': 'yapılıyor', // ← board
  'story.beatOpen': 'açık', // ← board
  'story.cast': 'Bu hikâyedeki kadro', // ← board

  'relight.action': 'Yeniden ışıklandır',
  'relight.title': 'Bu resim yeniden ışıklandırılsın mı?',
  'relight.body':
    'Resmin üzerinden hafif bir geçiş — ışığı ve parçalar arasındaki gölgeleri oturtur. Hiçbir şey yer değiştirmez, kimse değişmez; düz birleşik hâli de saklanır.',
  'relight.confirm': 'Işıklandır',
  'relight.cost': 'Yeniden ışıklandırmak {gen} harcar',
  'relight.working': 'Işıklandırılıyor',
  'relight.done': 'Işıklandırıldı',
  'relight.revert': 'düz birleşik hâline dön',
  'relight.failed': 'Bu geri gelmedi — düz birleşik hâli hâlâ burada.',

  'formats.kicker': '{story} · biçimler', // ← board
  'formats.title': 'Bu ne olsun?', // ← board
  'formats.meta': '{count} an · {ready} resim hazır · her biçim hikâyeden başlar', // ← board
  'formats.pick': 'Hangi biçim', // ← board
  'formats.open': 'aç', // ← board
  'formats.opened': 'Açık', // ← board
  'formats.ages': '{min}–{max} yaş',
  'formats.noIllustration': 'henüz resmi yok',
  'formats.stateNotStarted': 'başlanmadı', // ← board
  'formats.stateStartsFromStory': 'hikâyeden başlar', // ← board
  'formats.stateTakesOne': 'bir sahne alır', // ← board
  'formats.stateScenes': '{count} sahne', // ← board
  'formats.stateAllFromStory': 'hepsi hikâyeden', // ← board
  'formats.stateChanged': '{count} tanesi burada değişti', // ← board
  'formats.stateNothingToChange': 'değişecek bir şey yok', // ← board
  'formats.railBeats': 'Anlar', // ← board
  'formats.railFormats': 'Biçimler', // ← board
  'formats.backToStory': 'hikâyeye dön', // ← board
  'formats.railNotStarted': 'başlanmadı', // ← board
  'formats.railFromStory': 'hikâyeden', // ← board
  'formats.railStoryItself': 'hikâyenin kendisi', // ← board
  'formats.railChanged': '{count} değişti', // ← board
  'formats.floorFree': 'Uyarlamak ücretsiz — bir resmi değiştirene kadar', // ← board
  'formats.floorNeedsOne': '{format} içinde bir şey seni bekliyor', // ← board
  'formats.floorNeedsMany': '{format} içinde {count} şey seni bekliyor',
  'formats.emptyTitle': 'Henüz yapılabilecek bir şey yok.',
  'formats.emptyBody':
    'Keepsake’ler hazır oldukça teker teker açılıyor. Bir duvarın arkasında saklanan bir şey yok — henüz yayımlanmış bir şey yok, o kadar.',
  'formats.needBeats': 'Önce bir an ekle; bu sayfa hikâyenin neye dönüşebileceğiyle dolsun.',
  'formats.headerState': '{format} · {count} sahne', // ← board
  'formats.make': '{format} yap', // ← board
  'formats.canvasTitle': 'Sahneler · {format}', // ← board
  'formats.canvasMeta': '{count} · {derived} hikâyeden · {changed} burada değişti', // ← board
  'formats.canvasMetaAll': '{count} · hepsi hikâyeden', // ← board
  'formats.canvasNote':
    'Her sahne hikâyenin resmiyle başlar. Burada birini değiştirirsen hikâyeyi izlemeyi bırakır; diğerleri izlemeye devam eder. Hikâyenin resmine dönmek her zaman ücretsiz.', // ← board
  'formats.listLabel': 'Bu biçimin sahneleri, sırayla', // ← board
  'formats.reorder': 'Sırala — {index}. sahne. Yukarı ve aşağı oklarını kullan.',
  'formats.moved': 'Sahne {total} içinde {index}. sıraya taşındı.',
  'formats.beatFrom': '{index}. an', // ← board
  'formats.wasBeat': 'eskiden {index}. an', // ← board
  'formats.addedHere': 'burada eklendi', // ← board
  'formats.badgeDerived': 'Hikâyeden', // ← board
  'formats.badgeOverridden': 'Burada değişti', // ← board
  'formats.badgeReframed': 'Burada değişti · yeniden çerçevelendi', // ← board
  'formats.badgeStale': 'Burada değişti · hikâye de değişti', // ← board
  'formats.badgeOrphaned': 'Bu an artık hikâyede yok', // ← board
  'formats.badgeAdded': 'Burada eklendi', // ← board
  'formats.makingInStory': 'Hikâyede yapılıyor', // ← board
  'formats.making': 'Yapılıyor',
  'formats.notDrawnYet': 'henüz çizilmedi',
  'formats.failed': 'geri gelmedi',
  'formats.openScene': 'aç',
  'formats.followAgain': 'hikâyeyi yine izle', // ← board
  'formats.menuFollowAgain': 'Hikâyeyi yine izle', // ← board
  'formats.takeNew': 'hikâyenin yenisini al', // ← board
  'formats.keepMine': 'benimkini tut', // ← board
  'formats.keepOwn': 'kendi başına tut', // ← board
  'formats.menuKeepOwn': 'Kendi başına tut', // ← board
  'formats.removeHereToo': 'buradan da çıkar', // ← board
  'formats.menuReframe': 'Bu biçim için yeniden çerçevele', // ← board
  'formats.menuAdjustFrame': 'Çerçeveyi düzenle', // ← board
  'formats.menuChange': 'Bunu burada değiştir', // ← board
  'formats.menuDuplicate': 'Çoğalt', // ← board
  'formats.menuRemove': 'Bu biçimden çıkar', // ← board
  'formats.sceneActions': '{index}. sahne işlemleri',
  'formats.addFromStory': 'Hikâyeden bir an ekle', // ← board
  'formats.addFromStoryPick': 'Hangi an',
  'formats.addNew': 'Yeni bir sahne ekle', // ← board
  'formats.addCost': 'hikâyeden almak ücretsiz · yeni bir sahne {gen}', // ← board
  'formats.whatItWillBe': 'Ne olacak', // ← board
  'formats.paperModel': 'kâğıt model', // ← board
  'formats.modelLabel': '{format} kâğıt modeli. Çevirmek için sürükle.', // ← board
  'formats.modelFallback': 'kâğıt model tarayıcıda yüklenir', // ← board
  'formats.modelNoForm': 'bu biçim için henüz kâğıt model yok',
  'formats.howOpen': 'Ne kadar açık', // ← board
  'formats.foldClosed': 'Kapalı', // ← board
  'formats.foldFolded': 'Kapalı', // ← board
  'formats.foldOpening': 'Açılıyor', // ← board
  'formats.foldOpen': 'Açık', // ← board
  'formats.dragToTurn': 'sürükleyip çevir', // ← board
  'formats.whereCard': 'Üstteki kart nerede',
  'formats.cardInStack': 'Destede',
  'formats.cardSlidingOut': 'Çekiliyor',
  'formats.cardBack': 'Arkası',
  'formats.sizesNotFinal': 'Ölçüler kesin değil.', // ← board
  'formats.sizesNotFinalModel':
    'Model oranları doğru, boyutları henüz değil — baskı ortağı belli olunca kesinleşir.', // ← board
  'formats.factPanels': 'Panel', // ← board
  'formats.factSpreads': 'Sayfa çifti', // ← board
  'formats.factCards': 'Kart',
  'formats.factPlanes': 'Düzlem',
  'formats.factScenes': 'Sahne',
  'formats.factTakes': 'Alır', // ← board
  'formats.factRange': '{min} – {max} · en iyi {ideal}', // ← board
  'formats.factPictures': 'Resimler', // ← board
  'formats.factPicturesFlat': 'düz baskı · her birine bir sahne', // ← board
  'formats.factPicturesLayers': 'katmanlar · tek sahne, düzlem düzlem',
  'formats.factLines': 'Satırlar', // ← board
  'formats.factLinesUnder': 'her resmin altında', // ← board
  'formats.factLinesNone': 'yok — düzlemler kesilir, yazı basılmaz',
  'formats.factPage': 'Sayfa', // ← board
  'formats.factPageSquare': 'kare · satır solda, resim sağda', // ← board
  'formats.fitOk': '{count} sahne sığar.', // ← board
  'formats.fitOkOne': '1 sahne sığar.',
  'formats.fitWaitingOne': 'Bir tanesi çözülmeyi bekliyor.', // ← board
  'formats.fitWaitingMany': '{count} tanesi çözülmeyi bekliyor.',
  'formats.fitTooFew': 'En az {need} sahne alıyor; sende {have} var.',
  'formats.fitTooMany': 'En fazla {holds} sahne alıyor; sende {have} var. Burada birkaçını çıkar.',
  'formats.fitIdeal': 'En iyi yaklaşık {ideal} sahneyle okunuyor.',
  'formats.fitAddInStory': 'İstersen hikâyeye an ekle.', // ← board
  'formats.remove': 'Bu biçimi kaldır', // ← board
  'formats.removeNoTouch': 'hikâyeye dokunmaz', // ← board
  'formats.removeTitle': '{format} kaldırılsın mı?', // ← board
  'formats.removeBodyChanged':
    'Burada değiştirdiğin {count} sahne gider. Hikâye ve resimleri olduğu gibi kalır — {format} için istediğin zaman yeniden başlayabilirsin.', // ← board
  'formats.removeBodyOne':
    'Burada değiştirdiğin sahne gider. Hikâye ve resimleri olduğu gibi kalır — {format} için istediğin zaman yeniden başlayabilirsin.',
  'formats.removeBodyNone':
    'Burada bir şey değişmedi, yani kaybolan bir şey yok. Hikâye ve resimleri olduğu gibi kalır — {format} için istediğin zaman yeniden başlayabilirsin.',
  'formats.removeKeep': 'Vazgeç', // ← board
  'formats.removeConfirm': 'Kaldır', // ← board
  'formats.removed': '{format} kaldırıldı. Hikâyeye dokunulmadı.',
  'formats.refusedTitle': 'Bu kalır.', // ← board
  'formats.refusedBody':
    'Bundan bir hatıra yapıldı, o yüzden kalıyor — böylece siparişin neyden yapıldığı hep belli olur.', // ← board
  'formats.refusedOk': 'Tamam', // ← board
  'formats.startMeta': 'başlanmadı', // ← board
  'formats.startBody':
    'Bu biçim hikâyenin {count} anıyla başlar — her an bir sahne olur. Başlamak ücretsiz; hikâyeye dokunmaz.', // ← board
  'formats.startBodyHero':
    'Bu biçim tek bir sahne alır; katmanları düzlem olur. En kalabalık anla başlar — sonra istediğini seçersin.', // ← board
  'formats.start': 'Hikâyeden başla', // ← board
  'formats.starting': 'Başlıyor…',
  'formats.bookTitle': 'Sayfalar · {format}', // ← board
  'formats.bookMeta': '{count} sayfa çifti · hepsi hikâyeden', // ← board
  'formats.bookNote':
    'Burada değiştirecek bir şey yok: basılı kitap hikâyenin kendisi. Bir an değiştirmek istersen, hikâyede değiştir — kitap onu izler.', // ← board
  'formats.bookCover': 'Kapak · başlık ve {index}. anın resmi', // ← board
  'formats.bookCoverNone': 'Kapak · başlık, ve çizilince ilk resim',
  'formats.changeInStory': 'hikâyede değiştir', // ← board
  'formats.coverRow': 'k', // ← board

  'formats.composerKicker': '{format} · {index}. sahne',
  'formats.composerTitle': 'Bu sahne',
  'formats.composerFramed': '{format} için çerçevelendi · {w}:{h}',
  'formats.composerBack': 'geri dön · {format}',
  'formats.composerNote':
    'Burada değiştirdiklerin yalnızca {format} için — hikâyenin anı olduğu gibi kalır.',
  'formats.drawOverride': 'Bu sahneyi çiz',
  'formats.drawOverrideAgain': 'Yeniden çiz',
  'formats.drawOverrideTitle': 'Bu sahne çizilsin mi?',
  'formats.drawOverrideBodyFree':
    '{pieces} yalnızca {format} için tek bir resme dönüşür. Kullandığı her parça zaten hazır, yani kimsenin yeni bir hâli çizilmeyecek.',
  'formats.drawOverrideBodyCost':
    '{pieces} yalnızca {format} için tek bir resme dönüşür. Bunlardan {count} tanesi henüz çizilmedi, önce onlar yapılır.',
  'formats.sceneStatusNotDrawn': 'Bu sahne henüz çizilmedi',
  'formats.sceneStatusFollows': 'Hikâyeyi izliyor',

  'proof.kicker': 'Yap · {format}', // ← board
  'proof.title': 'Baskı provası', // ← board
  'proof.meta': 'kapak + {count} panel · her resim hazır · hikâyenin sürümlerine sabitlendi', // ← board
  'proof.metaSpreads':
    'kapak + {count} sayfa çifti · her resim hazır · hikâyenin sürümlerine sabitlendi',
  'proof.metaPieces': '{count} parça · her resim hazır · hikâyenin sürümlerine sabitlendi',
  'proof.metaWaiting': '{count} resim hâlâ yapılıyor',
  'proof.metaWaitingOne': 'bir resim hâlâ yapılıyor',
  'proof.metaNeedsYou': 'tuvalde bir sahne seni bekliyor',
  'proof.marksLabel': 'Baskı işaretleri', // ← board
  'proof.asItLooks': 'Göründüğü gibi', // ← board
  'proof.withMarks': 'Baskı işaretleriyle', // ← board
  'proof.note':
    'Basılacak olan tam olarak bu: her panel, her satır, sırasıyla. Sözleri kontrol et — resimler hikâyenin resimleri, burada değişmezler.', // ← board
  'proof.noteSpreads':
    'Basılacak olan tam olarak bu: her sayfa çifti, her satır, sırasıyla. Sözleri kontrol et — resimler hikâyenin resimleri, burada değişmezler.',
  'proof.sizesNotFinal':
    'Oranlar doğru; kâğıt boyutu ve kalınlığı baskı ortağı belli olunca kesinleşir. Siparişten önce kesinleşmiş hâlini görürsün.', // ← board
  'proof.label': '{format}, düz serilmiş', // ← board
  'proof.labelSpreads': '{format}, sayfa sayfa',
  'proof.labelPieces': '{format}, parça parça',
  'proof.fold': 'kat', // ← board
  'proof.bleed': 'taşma',
  'proof.cover': 'kapak', // ← board
  'proof.theEnd': 'son', // ← board
  'proof.panelFrom': 'hikâyeden', // ← board
  'proof.panelChanged': 'burada değişti', // ← board
  'proof.panelAdded': 'burada eklendi',
  'proof.panelMaking': 'yapılıyor',
  'proof.panelNeedsYou': 'seni bekliyor',
  'proof.noWords': 'henüz söz yok',
  'proof.pageNumber': '{index}. sayfa',
  'proof.cardNumber': '{index}. kart',
  'proof.planeNumber': '{index}. düzlem · {role}',
  'proof.backToChange': 'bir şeyi değiştirmek için {format} tuvaline dön', // ← board
  'proof.summaryPanels':
    '{count} panel · düz baskı · tek yüz · yeni piksel yok — hepsi hikâyenin resimleri', // ← board
  'proof.summarySpreads':
    '{count} sayfa çifti · düz baskı · yeni piksel yok — hepsi hikâyenin resimleri',
  'proof.summaryPieces': '{count} parça · yeni piksel yok — hepsi hikâyenin resimleri',
  'proof.whatArrives': 'Ne gelecek', // ← board
  'proof.patara': 'Atlas Nook Patara', // ← board
  'proof.theThing': 'Nesne', // ← board
  'proof.panels': 'Paneller', // ← board
  'proof.spreads': 'Sayfa çiftleri',
  'proof.pieces': 'Parçalar',
  'proof.panelsCount': '{count} · kapak + {scenes} sahne', // ← board
  'proof.spreadsCount': '{count} · her sahneye bir tane, bir de kapak',
  'proof.piecesCount': '{count}',
  'proof.paper': 'Kâğıt', // ← board
  'proof.paperNote': 'ölçüler kesinleşince', // ← board
  'proof.when': 'Ne zaman', // ← board
  'proof.whenNote': 'basılıp postalanır', // ← board
  'proof.after': 'Sonra', // ← board
  'proof.afterNote': 'Hikâyeyi değiştirirsen bu değişmez — yapıldığı sürümlere sabitlendi.', // ← board
  'proof.priceLine': '{price} · {lead} içinde gönderilir',
  'proof.priceNote':
    'Fiyat ve süre kataloğun; baskı ortağı ödeme sırasında onaylar ve tahsil eder. Stüdyo hiçbir zaman ödeme almaz.', // ← board
  'proof.goesToCheckout': 'ödeme sayfasına gider', // ← board
  'proof.order': '{format} sipariş et', // ← board
  'proof.orderTitle': 'Ödemeye geçelim mi?', // ← board
  'proof.orderBody':
    'Stüdyodan çıkıp baskı ortağımızın sitesinde ödersin. Siparişle birlikte yalnızca baskı dosyaları gider — çocuğunla ilgili hiçbir şey gitmez.', // ← board
  'proof.orderCost': 'fiyat orada görünür', // ← board
  'proof.orderNotYet': 'Vazgeç', // ← board
  'proof.orderGo': 'Ödemeye geç', // ← board
  'proof.checkoutNotSetUp': 'Sipariş, Patara mağazasıyla birlikte açılacak — henüz değil.',
  'proof.orderFailed': 'Bu gitmedi. Hiçbir şey sipariş edilmedi.',
  'proof.disabledWaiting': '{count} resim hâlâ yapılıyor',
  'proof.disabledWaitingOne': 'bir resim hâlâ yapılıyor',
  'proof.disabledOrphan': 'önce tuvalde bir sahne seni bekliyor',
  'proof.disabledFit': 'bu henüz sığmıyor — tuvalde değiştir',
  'proof.free': 'Prova ücretsiz · yeni resim çizilmez', // ← board
  'proof.railBack': 'geri dön · {format}', // ← board
  'proof.railTitle': '{format} · {story}', // ← board
  'proof.railPanels': 'Paneller', // ← board
  'proof.railCast': 'Kadro', // ← board
  'proof.railReady': 'hazır', // ← board
  'proof.madeNote': 'Bu var — {count} parça, hazır. Yeniden sipariş aynı dosyaları kullanır.',

  'browse.curated': '{count} parça · Atlas Nook derledi', // ← board
  'browse.curatedKind': '{kind} · derlenmiş', // ← board
  'browse.filter': 'Rafı süz',
  'browse.mine': 'Kitaplığında',
  'browse.inYourLibrary': 'Kitaplığında', // ← board
  'browse.notDrawn': 'henüz çizilmedi',
  'browse.useAsIs': 'Olduğu gibi kullan', // ← board
  'browse.makeItMine': 'Kendine uyarla', // ← board
  'browse.openIt': 'ona git', // ← board
  'browse.forked': '{name} artık senin. Hazır olduğunda çizdirirsin.',
  'browse.emptyTitle': 'Ortak raf boş.',
  'browse.emptyBody':
    'Başlangıçları Atlas Nook derliyor ve hazır oldukça burada görünüyorlar. Kendi parçaların kendi kitaplığında duruyor.',
  'browse.noMatchesTitle': 'Buna uyan bir şey yok.',
  'browse.noMatchesBody': 'Bir süzgeci kapatmayı dene.',
  'browse.shared': 'Ortak',

  'surface.opening': 'Açılıyor…',
  'surface.library': 'Kitaplığın',
  'surface.piece': 'Bir parça',
  'surface.pieceKicker': 'Kitaplık',
  'surface.meet': 'Karakterinle tanış',
  'surface.meetKicker': 'Kitaplık',
  'surface.stories': 'Hikâyelerin',
  'surface.storiesKicker': 'Hikâyeler',
  'surface.story': 'Bir hikâye',
  'surface.storyKicker': 'Hikâyeler',
  'surface.compose': 'Sahne düzenleyici',
  'surface.composeKicker': 'Hikâyeler',
  'surface.preview': 'Önizleme',
  'surface.previewKicker': 'Hikâyeler',
  'surface.make': 'Yap',
  'surface.makeKicker': 'Hikâyeler',
  'surface.browse': 'Kullanabileceğin ya da uyarlayabileceğin başlangıçlar',
  'surface.browseKicker': 'Ortak raf',
  'surface.intake': 'Elinde ne var?',
  'surface.intakeKicker': 'Yeni bir hikâye',
  'surface.placeholder': 'Bu yüzey henüz yapılmadı — çerçevesi yapıldı.',
  'surface.notFound': 'Bu adreste bir şey yok',
  'surface.notFoundBody': 'Bağlantı eski olabilir ya da parça arşivlenmiş olabilir.',
  'surface.notFoundAction': 'Kitaplığına git',
};
